import { render, staticRenderFns } from "./textPushModel.vue?vue&type=template&id=442d702e&lang=pug"
import script from "./textPushModel.vue?vue&type=script&lang=js"
export * from "./textPushModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports